// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaP = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M10.849 13.136V17h-1.75V6.948h3.668c2.716 0 3.64 1.358 3.64 3.108 0 2.1-1.442 3.08-3.78 3.08zm1.708-4.69h-1.708v3.192h1.68c1.218 0 2.128-.378 2.128-1.582 0-1.246-.896-1.61-2.1-1.61"
    />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaP;
